import {
  EWorkDebtorsActions,
  WorkDebtorsActions,
} from '@myStore/work-debtors/work-debtors.actions';
import {
  initialsWorkDebtorsState,
  IWorkDebtorsState,
} from '@myStore/work-debtors/work-debtors.state';

export const workDebtorsReducers = (
  state = initialsWorkDebtorsState,
  actions: WorkDebtorsActions
): IWorkDebtorsState => {
  switch (actions.type) {
    case EWorkDebtorsActions.GetWorkDebtorsRequest:
      return {
        ...state,
        workDebtorsNotes: {
          ...state.workDebtorsNotes,
          isLoading: true,
        },
      };
    case EWorkDebtorsActions.GetWorkDebtorsSuccess:
      return {
        ...state,
        workDebtorsNotes: {
          ...state.workDebtorsNotes,
          data: actions.payload,
          isLoading: false,
        },
      };
    case EWorkDebtorsActions.GetWorkDebtorsFailure:
      return {
        ...state,
        workDebtorsNotes: {
          ...state.workDebtorsNotes,
          isLoading: false,
          errors: actions.errors,
        },
      };
    case EWorkDebtorsActions.ClearWorkDebtors:
      return {
        ...state,
        workDebtorsNotes: {
          ...state.workDebtorsNotes,
          data: [],
          isLoading: false,
          errors: null,
        },
      };
    case EWorkDebtorsActions.GetWorkDebtorsByGroupRequest:
      return { ...state, isLoading: true };
    case EWorkDebtorsActions.GetWorkDebtorsByGroupSuccess:
      return { ...state, isLoading: false, data: actions.payload };
    case EWorkDebtorsActions.GetWorkDebtorsByGroupFailure:
      return { ...state, isLoading: false, errors: actions.errors };
    case EWorkDebtorsActions.ClearGetWorkDebtorsByGroup:
      return { ...state, data: null, isLoading: false, errors: null };
    case EWorkDebtorsActions.AddWorkDebtorsRequest:
      return { ...state, isLoadingChanges: true };
    case EWorkDebtorsActions.AddWorkDebtorsSuccess:
      return { ...state, success: true, isLoadingChanges: false };
    case EWorkDebtorsActions.AddWorkDebtorsFailure:
      return {
        ...state,
        isLoadingChanges: false,
        errors: actions.errors,
        success: false,
      };
    case EWorkDebtorsActions.ClearAddWorkDebtorsErrors:
      return {
        ...state,
        success: false,
        isLoadingChanges: false,
        errors: null,
      };
    default:
      return state;
  }
};
